import { render, staticRenderFns } from "./BranchMarketingHub.vue?vue&type=template&id=146848c2"
import script from "./BranchMarketingHub.vue?vue&type=script&lang=js"
export * from "./BranchMarketingHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports